export const KZN_FRAME_EVENTS = {
  RESIZE: 'window_resize',
  CAPTCHA_SUCCESS: 'captcha_success',
  FORM_SUBMITTED: 'form_submitted',
  OPEN_EMAIL: 'open_email',
  START_OVER: 'start_over',
  CHAT_USER: 'chat_user',
  BUILD: 'build',
  GENERATE_REQUIREMENTS: 'generate_requirements',
  ASK_MORE_QUESTIONS: 'ask_more_questions',
  SESSION_FLAGGED: 'session_flagged',
};

export type BusinessBuilderMailServices = 'gmail' | 'outlook';
